import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Box, FilterButton, Popover, TextInput } from '@pocketlaw/tetris';
import { useFilter } from '../useFilter';
export function NumberEqualsOperator(props) {
    var _a, _b;
    const { name } = props;
    const filter = useFilter(name);
    const [open, setOpen] = useState(filter.hasValue);
    const handleSetField = (ev) => {
        const { value } = ev.target;
        const numberValue = parseInt(value, 10);
        filter.setValue({
            eq: numberValue,
        });
    };
    return (<Popover shadow="300" open={open} padding={0} onClose={() => setOpen(false)} target={<FilterButton type="button" appearance={filter.isTouched ? 'draft' : 'default'} onClick={() => setOpen(!open)}>
          {((_a = filter.value) === null || _a === void 0 ? void 0 : _a.eq) || t({ message: 'Select value', comment: 'Search filter: Select value' })}
        </FilterButton>}>
      <Box px="md" pb="md">
        <TextInput label={t({ message: 'Equals', comment: 'Insights: Number range filter: Equals' })} placeholder={t({ message: 'Equals', comment: 'Insights: Number range filter: Equals' })} type="number" value={((_b = filter.value) === null || _b === void 0 ? void 0 : _b.eq) || ''} onChange={handleSetField}/>
      </Box>
    </Popover>);
}
